"use client";

import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

const Footer = () => {
  const { role } = useContext(AuthContext);

  const location = useLocation();
  const isActive = (path) => location.pathname.startsWith(path);

  const menuItems = {
    USER: [
      {
        path: "/user/stores",
        icon: "shopping_cart",
        title: "لیست فروشگاه‌ها",
      },
      {
        path: "/user/credit-requests",
        icon: "shopping_cart",
        title: "درخواست‌های ثبتی",
      },
      {
        path: "/user/transactions",
        icon: "receipt_long",
        title: "تراکنش‌ها",
      },
      {
        path: "/authentication/logout",
        icon: "logout",
        title: "خروج",
      },
    ],
    STORE: [
      {
        path: "/store/credit-requests",
        icon: "shopping_cart",
        title: "ثبت درخواست خرید",
      },
      {
        path: "/store/transactions",
        icon: "receipt_long",
        title: "تراکنش‌ها",
      },
      {
        path: "/authentication/logout",
        icon: "logout",
        title: "خروج",
      },
    ],
    ADMIN: [
      {
        path: "/admin/users",
        icon: "group",
        title: "کاربران",
      },
      {
        path: "/admin/stores",
        icon: "store",
        title: "فروشگاه‌ها",
      },
      {
        path: "/admin/categories",
        icon: "group",
        title: "'گروه کاربر'",
      },
      {
        path: "/admin/product/categories",
        icon: "category",
        title: "دسته‌بندی‌ها",
      },
      {
        path: "/admin/credit-requests",
        icon: "shopping_cart",
        title: "درخواستهای خرید",
      },
      {
        path: "/admin/transactions",
        icon: "receipt_long",
        title: "تراکنش‌ها",
      },
      {
        path: "/authentication/logout",
        icon: "logout",
        title: "خروج",
      },
    ]
  };

  // اگر نقش تعریف نشده بود (مثلاً هنوز لاگین نکرده)
  const currentMenu = menuItems[role] || [];

  return (
    <>
      <div className="flex-grow-1"></div>

      <footer className="footer-area bg-white text-center rounded-top-7">
        <p className="fs-14 d-none d-sm-block">
          © <span className="text-primary-div">حساب اعتباری</span> طراحی توسط{" "}
          <a
            href="https://webmaher.ir/"
            target="_blank"
            rel="noreferrer"
            className="text-decoration-none text-primary"
          >
            وب ماهر
          </a>
        </p>

        <div className="mobile-bottom-nav d-flex d-sm-none">
          {currentMenu.map((item) => (
            <Link
              to={item.path}
              className={`nav-item ${isActive(item.path) ? "active" : ""}`}
            >
              <i className="material-symbols-outlined">{item.icon}</i>
              <span className="title">{item.title}</span>
            </Link>
          ))}
        </div>

      </footer>
    </>
  );
};

export default Footer;
